import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "1.5",
      d: "M20 12.75h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2a2.25 2.25 0 0 1 0-4.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m7.606 11.606-.03.26C7.501 12.6 7.5 13.563 7.5 15s.001 2.4.076 3.135c.072.709.2 1.037.345 1.254l.146.197q.236.286.544.493l.087.053c.218.122.546.229 1.167.292.735.075 1.7.076 3.135.076h3l.499-.001 1.485 1.485q-.46.011-.995.015L16 22h-3l-.99-.001c-2.01-.008-3.175-.073-4.038-.555l-.195-.118a4 4 0 0 1-.99-.943l-.113-.16C6 19.213 6 17.809 6 15c0-2.3 0-3.66.37-4.63zm15.35 6.15c-.064 1.111-.225 1.86-.63 2.467l-.113.16q-.039.048-.078.096l-1.07-1.07q.007-.011.014-.02l.053-.087c.122-.218.229-.546.292-1.167l.012-.135H22c.346 0 .672-.09.956-.244M16.99 8c2.165.01 3.35.083 4.234.673.436.292.811.667 1.103 1.103.405.607.566 1.356.63 2.466A2 2 0 0 0 22 12h-.564l-.012-.135c-.063-.62-.17-.949-.292-1.167l-.053-.087a2.5 2.5 0 0 0-.493-.544l-.197-.146c-.217-.145-.545-.273-1.254-.345C18.4 9.501 17.435 9.5 16 9.5h-3c-.72 0-1.32 0-1.834.01L9.738 8.082c.617-.061 1.357-.077 2.273-.081L13 8h3z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M7.061 8 21 21.939"
    }, null, -1)
  ])))
}
export default { render: render }